export enum EnumLanguage {
  SPANISH = 'es',
  ENGLISH = 'en',
  PORTUGUESE = 'pt',
}
